export default "__VITE_ASSET__CKdA3kzy__";